import {mapNullToUndefined} from '../utils/zod';
import {CreateRigRequest} from './../api/generated/index.defs';
import {z} from 'zod';

export const rigSchema = z.object({
  partnerSiteId: z.number().min(1, 'Partner Site is required'),
  name: z.string().min(1, 'Name is required'),
  notificationEmails: mapNullToUndefined(z.string().optional()),
}) satisfies z.ZodSchema<CreateRigRequest>;

export type RigSchema = z.infer<typeof rigSchema>;
